import * as Yup from 'yup';
// eslint-disable-next-line no-unused-vars
import * as custom from '../../utils/yupCustom'; //Do not remove! required for custom methods import like strongPassword()

const ChangePasswordSchema = Yup.object().shape({
  currentPassword: Yup.string()
    .label('Current Password')
    .min(1)
    .max(50)
    .required(),
  newPassword: Yup.string()
    .label('New Password')
    .strongPassword()
    .required(),
  newPasswordConfirm: Yup.string()
    .label('Confirm New Password')
    .strongPassword()    
    .test('match', 'Passwords do not match', function(value) {
      return value === this.parent.newPassword;
    })
    .required()
    
});

export default ChangePasswordSchema;
